// eslint-disable
// this is an auto generated file. This will be overwritten

export const getDiscussion = `query GetDiscussion($id: ID!) {
  getDiscussion(id: $id) {
    id
    cid
    oid
    recordedAt
    topic
    comment
    recorder {
      id
      name
      type
    }
    status
    progress
    duration
    group {
      name
      seats {
        position
        memberId
      }
    }
    analysis
    annotations {
      id
      begin
      end
      label
      createdBy
      createdAt
      updatedBy
      updatedAt
    }
    stats
    timestamp
    options {
      isPrivate
      autoCorrection {
        enabled
        limit
      }
      useNewCaDa
      runAsr
      omitFullChannelAudio
    }
  }
}
`
export const listDiscussions = `query ListDiscussions($cid: ID!, $limit: Int, $nextToken: String) {
  listDiscussions(cid: $cid, limit: $limit, nextToken: $nextToken) {
    items {
      id
      cid
      oid
      recordedAt
      topic
      comment
      recorder {
        id
        name
        type
      }
      status
      progress
      duration
      group {
        name
        seats {
          position
          memberId
        }
      }
      annotations {
        id
        begin
        end
        label
        createdBy
        createdAt
        updatedBy
        updatedAt
      }
      stats
      timestamp
      options {
        isPrivate
        autoCorrection {
          enabled
          limit
        }
        useNewCaDa
        runAsr
        omitFullChannelAudio
      }
    }
    nextToken
  }
}
`
export const listAllDiscussions = `query ListAllDiscussions($filter: DiscussionFilterInput, $limit: Int, $nextToken: String) {
  listAllDiscussions(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      cid
      oid
      recordedAt
      topic
      comment
      recorder {
        id
        name
        type
      }
      status
      progress
      duration
      group {
        name
        seats {
          position
          memberId
        }
      }
      annotations {
        id
        begin
        end
        label
        createdBy
        createdAt
        updatedBy
        updatedAt
      }
      stats
      timestamp
      options {
        isPrivate
        autoCorrection {
          enabled
          limit
        }
        useNewCaDa
        runAsr
        omitFullChannelAudio
      }
    }
    nextToken
  }
}
`
export const getAudioUrl = `query GetAudioUrl($apikey: ID!, $id: ID!) {
  getAudioUrl(apikey: $apikey, id: $id) {
    error
    result
  }
}
`
